module.exports = __webpack_public_path__ + "static/media/G1-2-Alice-Saitta-cod22.a5546ce4.png";